export function validatePhoneNumber(formData) {
  const { user_phone_number } = formData;
  if (!user_phone_number) {
    return { user_phone_number: "Please enter a mobile number" };
  }

  const phoneRegex =
    /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  const isValidPhone = phoneRegex.test(user_phone_number);

  if (!isValidPhone) {
    return { user_phone_number: "Please enter a valid phone number" };
  }

  return null;
}
